// extracted by mini-css-extract-plugin
module.exports = {"Container":"ZC1AVJ"};